import React, { useState, useEffect } from 'react';
import '../styles/HeroSlider.css';

const HeroSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Масив зображень для каруселі (LITO_imgs/wheel)
  const images = [
    '/assets/wheel/1.jpg',
    '/assets/wheel/2.jpg',
    '/assets/wheel/3.jpg',
    '/assets/wheel/4.jpg',
    '/assets/wheel/5.jpg'
  ];

  // Автоматична зміна слайдів кожні 4 секунди
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="hero-slider">
      <div
        className="hero-slider-wrapper"
        onClick={goToNext}
      >
        {images.map((src, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
          >
            <img
              src={src}
              alt={`Підлітки займаються творчістю - фото ${index + 1}`}
              className="hero-image"
              loading={index === 0 ? 'eager' : 'lazy'}
            />
          </div>
        ))}
        <div className="hero-image-overlay"></div>
        <div className="hero-image-grain"></div>
        
      </div>
      
      {/* Індикатори */}
      <div className="slider-indicators">
        {images.map((_, index) => (
          <button
            key={index}
            className={`slider-indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Перейти до зображення ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
